import { render } from "./InterestsList.vue?vue&type=template&id=7bde5ce8"
import script from "./InterestsList.vue?vue&type=script&lang=js"
export * from "./InterestsList.vue?vue&type=script&lang=js"

import "./InterestsList.vue?vue&type=style&index=0&id=7bde5ce8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__